import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { SignupService } from './signup.service';
import { AgencyComponent } from './agencies/agencies.component';
import { HttpErrorResponse } from '@angular/common/http';
import { HomeService } from '../home.service';
import { Subscription } from 'rxjs';
import { CountryData } from '../../interfaces/country.interface';
import { HeroVariant } from '../hero/hero.component';

@Component({
	selector: 'signup',
	templateUrl: './signup.component.html',
	styleUrls: ['./signup.component.scss'],
	providers: [SignupService]
})

export class SignupComponent implements OnInit, OnDestroy {
  @ViewChild(AgencyComponent) agenciesFormComponent!: AgencyComponent;
  @ViewChild('container') container!: ElementRef;
  @Input() clientSetting: any;
  @Input() variant: HeroVariant = 'classic';
  @Output() successEvent = new EventEmitter<void>();
  @Output() errorEvent = new EventEmitter<void>();
  public getClientsSettingAppAuth: any;
  activeBtn: string = 'agencies';
  activeForm: string = 'agencies';
  public countries: CountryData[] = [];

  private countrySubscription!: Subscription;

	constructor(
    private _homeService: HomeService
	){

	}

  ngOnInit(): void {
      this.getClientsSettingAppAuth = this.clientSetting;
      this.getCountriesData();
  }

  ngOnDestroy(): void {
    if(this.countrySubscription) {
      this.countrySubscription.unsubscribe();
    }
  }

  changeActiveBtn(btn: string) {
    this.activeBtn = btn;
  }

    getCountriesData() {

      if(this.countries && this.countries.length === 0) {
        this.countrySubscription = this._homeService.getCountriesData().subscribe({
          next: (res: CountryData[]) => {
            if(res && Array.isArray(res) && res.length > 0) {
              this.countries = res;
            }
          },
          error: (error: HttpErrorResponse) => {
            console.error(error);
          }
        });
      }
  }

  /**

changeForm es una función que permite cambiar el formulario activo y desplazar el contenedor hasta su inicio.
@param form - Representa el nombre del formulario a activar.
@param event - Representa un evento opcional, en caso de ser enviado, es previsto su comportamiento por defecto.
*/


  changeForm(form: string, event?: Event) {
    if (event) {
      event.preventDefault();
    }
    if (this.activeForm === form) {
      return;
    }
    this.activeForm = form;
    if (this.container && this.container.nativeElement) {
      const currentPos = this.container.nativeElement.scrollTop;
      if (currentPos !== this.container.nativeElement.offsetTop) {
        this.container.nativeElement.scrollTop = this.container.nativeElement.offsetTop;
      }
    }
  }

  onAgenciesFormSuccess() {
    this.successEvent.emit();

  }

  onAgenciesFormError() {
    this.errorEvent.emit();
  }

}
